import React, { useEffect, useState, useRef, useContext } from "react";
import { Page } from "../";

import { PlanoService, ProcessoBeneficioService } from "./../../services";
import { Ativo } from "./Ativo";
import { Assistido } from "./Assistido";
import { AtivoSaldado } from "./AtivoSaldado";
import { NaoParticipante } from "./NaoParticipante";
import { Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { NumFuncionalidade } from "../Page";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from "../../entidades";
import { ListaPlanos, ListaProcesso, LoadingComponent } from "../../components";
import { HomeContext } from "../../contexts";

export const Home: React.FC = ({ ...props }) => {
  const page = useRef<Page>();
  const context = useContext(HomeContext);

  const Pensionista = localStorage.getItem("pensionista") === "true";

  const [Planos, setPlanos] = useState<Array<PlanoVinculadoEntidade>>(new Array<PlanoVinculadoEntidade>());
  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [CdPlano, setCdPlano] = useState<string>("");
  const [ProcessosBeneficio, setProcessosBeneficio] = useState<Array<ProcessoBeneficioEntidade>>(new Array<ProcessoBeneficioEntidade>());
  const [Processo, setProcesso] = useState<ProcessoBeneficioEntidade>(new ProcessoBeneficioEntidade());
  const [EspecieAnoNumProcesso, setEspecieAnoNumProcesso] = useState<string>("");
  // const [Pensionista, setPensionista] = useState<boolean>(false);
  const [Funcionalidade, setFuncionalidade] = useState<NumFuncionalidade>();
  const [Loading, setLoading] = useState<boolean>(false);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      page.current.loading(true);
      setLoading(true);
      try {
        const planos = await PlanoService.Buscar();

        if (planos.length > 0) {
          const plano = planos[0];
          const cdPlano = plano.CD_PLANO;

          await buscarProcessos(plano);

          let Funcionalidade = NumFuncionalidade.HOME_ATIVOS_E_AUTOPATROCINADOS;

          if (plano.CD_CATEGORIA === "4")
            Funcionalidade = NumFuncionalidade.HOME_ASISSTIDOS

          if (Pensionista)
            Funcionalidade = NumFuncionalidade.HOME_PENSIONISTAS

          setFuncionalidade(Funcionalidade);
          setPlanos(planos);
          setPlano(plano);
          setCdPlano(cdPlano);

          context.salvarPlano(plano);
        }
      }
      catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        page.current.loading(false);
        setLoading(false);
      }
    })();
  }, []);

  async function carregarPlano(Plano: PlanoVinculadoEntidade) {
    const CdPlano = Plano.CD_PLANO;
    const planoSelecionado = Planos.filter(plano => plano.CD_PLANO === CdPlano)[0];

    setCdPlano(CdPlano);
    setPlano(planoSelecionado);

    context.salvarPlano(planoSelecionado);

    await buscarProcessos(planoSelecionado);
  };

  async function buscarProcessos(Plano: PlanoVinculadoEntidade) {
    if (Plano.CD_CATEGORIA === "4") {
      const processosBeneficio: Array<ProcessoBeneficioEntidade> = await ProcessoBeneficioService.BuscarPorPlano(Plano.CD_PLANO);

      if (processosBeneficio.length > 0) {
        const processo = processosBeneficio[0];
        const especieAnoNumProcesso = processo.ESPECIE_ANO_NUM_PROCESSO;
        // const especieAnoNumProcesso = processo.CD_ESPECIE + processo.ANO_PROCESSO + processo.NUM_PROCESSO;

        setProcessosBeneficio(processosBeneficio);
        setProcesso(processo);
        setEspecieAnoNumProcesso(especieAnoNumProcesso);

        context.salvarProcessoBeneficio(processo);
      }
    }
  };

  async function carregarProcesso(processoBeneficio: ProcessoBeneficioEntidade) {
    const especieAnoNumProcesso = processoBeneficio.ESPECIE_ANO_NUM_PROCESSO;
    const processoSelecionado = ProcessosBeneficio.filter(processo => processo.ESPECIE_ANO_NUM_PROCESSO === especieAnoNumProcesso)[0];

    setProcesso(processoSelecionado);
    setEspecieAnoNumProcesso(especieAnoNumProcesso);

    context.salvarProcessoBeneficio(processoSelecionado);
  }

  return (
    <Page Funcionalidade={Funcionalidade} {...props} ref={page}>
      <>
        {Loading && <LoadingComponent />}

        {!Loading && Erro !== "" && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

        {!Loading && Erro === "" && (<>
          {Planos.length > 1 &&
            <ListaPlanos
              planos={Planos}
              onChange={carregarPlano}
              cdPlanoAtivo={CdPlano}
            />
          }

          {ProcessosBeneficio.length > 1 &&
            <ListaProcesso
              processos={ProcessosBeneficio}
              dsProcessoAtivo={Processo.DS_PROCESSO}
              onChange={carregarProcesso}
              textoInstrucao={"Selecione um processo de benefício"}
            />
          }

          {Plano.CD_PLANO === "0003" && (Plano.CD_CATEGORIA === "1" || Plano.CD_CATEGORIA === "3") &&
            <AtivoSaldado />
          }
          {Plano.CD_PLANO !== "0003" && (Plano.CD_CATEGORIA === "1" || Plano.CD_CATEGORIA === "3") &&
            <Ativo />
          }
          {Plano.CD_CATEGORIA === "4" &&
            <Assistido />
          }
          {Plano.CD_CATEGORIA === undefined &&
            <NaoParticipante />
          }
        </>)}
      </>
    </Page>
  )
}